export default "__VITE_ASSET__3ad32e92__"